import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import CodeInfoSection from 'components/CodeInfoSection';
import { Divider, Typography } from 'material-ui';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoNotes extends Component {

    render() {
        const { model, onDate } = this.props;
        const title = ((new Date('2022-01-01 00:00:00')) > onDate) ? 'Примечания к ТН ВЕД ЕАЭС' : 'Примечания к ТНВЭД ЕАЭС (Решение Совета ЕЭК от 14.09.2021 г. N 80)';
        return (
            <CodeInfoSection title={title}
                expanded={false} action={'notes'} count={model.notes.length}>
                <div>
                    {model.notes.map((note, index) => (
                        <div key={index} >
                            <Typography component='div' paragraph >
                                <div dangerouslySetInnerHTML={{ __html: note }}></div>
                            </Typography>
                            {index < model.notes.length - 1 &&
                                <Typography component='div' paragraph >
                                    <Divider />
                                </Typography>
                            }
                        </div>
                    ))}
                </div>
            </CodeInfoSection>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoNotes.js